module.exports = __webpack_public_path__ + "img/1-md.25c4c643.jpg";